import React, { useState, useMemo, useEffect } from 'react';
import { ButtonBase, makeStyles, TextField, Typography } from '@material-ui/core';
import _ from 'lodash';
import AddRemarksPop from '../PopWindows/Newbooking/AddRemarksPop';
import { classNames } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  topBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  typography: {},
  textField: {
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    padding: '0 1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#2e4469',
      lineHeight: '1.8rem',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },
  buttonBase: {},
  addRemarksItem: {
    lineHeight: '3.5rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    paddingLeft: '1.188rem',
    cursor: 'pointer',
  },
  labelError: {
    '& *': {
      color: '#f44336 !important',
    },
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

export default function AddTextInput({
  allData,
  value,
  onChange,
  title,
  btnText,
  className,
  style,
  popClassName,
  rows,
  errorMsg,
  onBlur,
  btnId,
  textId,
  popId,
  disabled = false,
}) {
  const [DataList, setDataList] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const closePop = () => {
    setAnchorEl(null);
  };
  const [valueInput, setValueInput] = useState(value);
  useEffect(() => {
    if (Array.isArray(allData)) {
      const result = {};
      const list = (value || '').split('\n');
      allData.forEach((item) => {
        result[item] = list.includes(item);
      });
      setDataList(result);
    }
  }, [allData, value]);

  useEffect(() => {
    setValueInput(value);
  }, [value]);

  const onChangeHandle = (event) => {
    setValueInput(event.target.value);
  };

  const [initFlag, setInitFlag] = useState(false);
  const onBlurHandle = (event) => {
    setInitFlag(true);
    if (Array.isArray(allData)) {
      const valueList = event.target.value;
      const newValue = valueList
        .split('\n')
        .filter((item) => {
          return item;
        })
        .join('\n');
      setValueInput(newValue);
      if (typeof onChange === 'function') {
        onChange(newValue);
      }
    }
  };

  useEffect(() => {
    if (initFlag) {
      if (typeof onBlur === 'function') {
        onBlur();
      }
    }
  }, [value]);

  const onClickHandle = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const itemClickHandle = (val) => {
    return () => {
      const newDataList = { ...DataList, [val]: true };
      setDataList(newDataList);
      if (Array.isArray(allData)) {
        const newValue = `${value}${value ? '\n' : ''}${val}`;
        setValueInput(newValue);
        if (typeof onChange === 'function') {
          onChange(newValue);
        }
      }
    };
  };

  const itemList = useMemo(() => {
    let result = [];
    if (Array.isArray(allData)) {
      result = allData.filter((item) => {
        return !DataList[item];
      });
    }
    return result;
  }, [DataList]);

  const classes = useStyles();
  return (
    <div className={className} style={style}>
      <div className={classes.topBox}>
        <div className={errorMsg ? classNames(classes.typography, classes.labelError) : classes.typography}>
          {title}
        </div>
        <ButtonBase id={btnId} className={classes.buttonBase} onClick={onClickHandle}>
          {btnText}
        </ButtonBase>
      </div>
      <TextField
        id={textId}
        className={errorMsg ? classNames(classes.textField, classes.inputError) : classes.textField}
        multiline={true}
        fullWidth={true}
        rows={rows ?? 4}
        value={valueInput}
        onChange={onChangeHandle}
        placeholder=""
        onBlur={onBlurHandle}
        disabled={disabled}
        style={{ backgroundColor: disabled ? '#f5f5f5' : '' }}
      />
      {errorMsg ? <Typography className={classes.errorMsg}>{errorMsg}</Typography> : ''}
      {anchorEl ? (
        <AddRemarksPop id={popId} closePop={closePop} anchorEl={anchorEl} className={popClassName}>
          {_.map(itemList, (item) => {
            if (DataList.hasOwnProperty(item)) {
              return (
                <Typography key={item} className={classes.addRemarksItem} onClick={itemClickHandle(item)}>
                  {item}
                </Typography>
              );
            }
            return null;
          })}
        </AddRemarksPop>
      ) : (
        ''
      )}
    </div>
  );
}
